import { NgTemplateOutlet } from '@angular/common';
import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { Filter } from '../../../models/filter-models';
import { CustomRuleGroupPanelComponent } from '../custom-rule-group-panel/custom-rule-group-panel.component';
import { CustomRuleGroupsTabController } from '../custom-rule-groups-tab.controller';

@Component({
  selector: 'app-custom-rule-groups-list',
  templateUrl: './custom-rule-groups-list.component.html',
  styleUrls: ['../custom-rule-groups-shared.scss'],
  imports: [CustomRuleGroupPanelComponent, NgTemplateOutlet],
})
export class CustomRuleGroupsListComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) cosmetic = false;
  @Input({ required: true }) controller!: CustomRuleGroupsTabController;
  @Input() addGroupButtonLabel = 'Add new Custom Rule Group';

  @ContentChild('defaultGroupTopSlot') defaultGroupTopSlot?: TemplateRef<unknown>;
}
